import React, { Component } from 'react';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import { UiLoginHelper } from '../common/helpers/UiLoginHelper';
import { Helper } from '../common/helpers/Helper';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { StyleSheet, css } from 'aphrodite';
// import { AppCommonTheme } from '../styles/Styles';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export class NumericOTPInput extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <FormControl fullWidth margin='normal' className={this.props.formcontrolmargin}>
        <p className={css(Styles.textFieldLabel)}>{Helper.getString('otp')}</p>
        <TextField
          {...this.props} type='password'
          className={css(Styles.textField)}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: css(Styles.textFieldContentInput)
            }
          }}
          placeholder={Helper.getString('otp')}
        />

      </FormControl>
    )
  }
}

export class PasswordInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormControl fullWidth margin='normal' className={this.props.formcontrolmargin}>
        <p className={css(Styles.textFieldLabel)}>
          {this.props.placeholder ? this.props.placeholder : Helper.getString('enterPassword')}</p>
        <TextField
          {...this.props} type='password'
          className={css(Styles.textField)}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: css(Styles.textFieldContentInput)
            }
          }}
          placeholder={this.props.placeholder ? this.props.placeholder : Helper.getString('enterPassword')}
        />

      </FormControl>
    )
  }
}

export class UsernameInput extends Component {
  constructor(props) {
    super(props);
    this.usernametype = this.props.usernametype
  }

  render() {
    return (
      <FormControl fullWidth margin='normal' className={this.props.formcontrolmargin}>
        {this.usernametype === UiLoginHelper.UserNameType.PHONE ?
          <p className={css(Styles.textFieldLabel)} htmlFor='mobile-number'>{Helper.getString('enterMobile')}</p>
          :
          <p className={css(Styles.textFieldLabel)} htmlFor='email'>{Helper.getString('email')}</p>
        }
        <TextField
          {...this.props}
          className={css(Styles.textField)}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: css(Styles.textFieldContentInput)
            }
          }}
          placeholder={this.usernametype === UiLoginHelper.UserNameType.PHONE ?
            Helper.getString('enterMobile') : Helper.getString('email')}
        />
      </FormControl>
    )
  }
}

export class SimpleTextInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormControl fullWidth margin='normal' className={this.props.formcontrolmargin}>
        <p className={css(Styles.textFieldLabel)} htmlFor='email'>{this.props.inputlabel}</p>
        <TextField
          {...this.props}
          className={css(Styles.textField)}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: css(Styles.textFieldContentInput)
            }
          }}
          placeholder={this.props.inputlabel}
        />
      </FormControl>
    )
  }
}

export class SimpleSelectInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormControl fullWidth margin='normal' className={this.props.formcontrolmargin}>
        <p className={css(Styles.textFieldLabel)} htmlFor='email'>{this.props.inputlabel}</p>
        <Autocomplete
          {...this.props}
          getOptionLabel={(option) => option.label || option.text}
          classes={{
            paper: css(Styles.listBoxPaper),
            popupIndicator: css(Styles.popupIndicator),
            popper: css(Styles.popper),
          }}
          renderInput={(params) => <TextField {...params}
            className={css(Styles.textField)}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              classes: {
                root: css(Styles.textFieldContentInput)
              }
            }}
            placeholder={this.props.inputlabel}
          />}
        />

      </FormControl>
    )
  }
}

const Styles = StyleSheet.create({
  textFieldLabel: {
    //margin: AppCommonTheme.pMargin,
    marginBottom: 12,
    color: '#4F4F4F',
    fontSize: 18,
    '@media (max-width: 767px)': {
      fontSize: 16,
    }
  },
  textField: {
    borderRadius: 12,
    //backgroundColor: AppTheme.secondaryColor,
  },
  textFieldContentInput: {
    padding: 9,
    paddingLeft: 15,
    fontSize: 16,
    borderRadius: 12,
    //color: AppCommonTheme.appFontSecondaryColor,
    backgroundColor: '#F7F7F7',
    // border: '0.5px solid' + AppTheme.secondaryBg
  },
  textFieldContentInputDisabled: {
    backgroundColor: AppTheme.primaryBg,
    border: '0.5px solid ' //+ AppCommonTheme.borderColor
  },

  popupIndicator: {
    marginRight: 10
  },
  popper: {
    zIndex: 130000
  },

  listBoxPaper: {
    borderRadius: 12
  },
})



// WEBPACK FOOTER //
// ./src/components/TextInputs.js